export const Week = [
    {
        "id": 1,
        "name": "Tuần 1"
    },
    {
        "id": 2,
        "name": "Tuần 2"
    },
    {
        "id": 3,
        "name": "Tuần 3"
    },
    {
        "id": 4,
        "name": "Tuần 4"
    },
    {
        "id": 5,
        "name": "Tuần 5"
    }
]